import React, {useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {Response} from "../API/response/user";
import {IntlMessage, IntlMessageValue, SearchJSX, SpinnerJSX} from "../../../@WUM/core/Elements";
import {refresh} from "../../ticketsystem/modules/new/Pages/SingleTask";
import TableMaker from "../../../@WUM/core/tablemaker";
import PaginationJSX from "../../../@WUM/core/form-serilizer/elements/pagination";
import {handleSucces} from '../../../@WUM/core/Function/index'
import {CryptDecrypt} from "../../../@WUM/core/Elements/crypt/Crypt";
import {ResponseAllSRoles} from "../../settings/Member/API/response/member/member";


const EmployeeOverview = (value: any) => {
    const {page} = useParams<{ page: string }>()
    const history = useNavigate()
    const [fetchData, setFetchData] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [load, setLoad] = useState(0)

    let limit: number | undefined
    if (typeof page === 'string') {
        limit = parseFloat(page) * 10 - 10
    }

    const Store = useSelector((state: any) => state)

    const response = Response(
        limit,
        searchValue !== '?search=1&' ? searchValue : '',
        fetchData
    )

    const Roles = ResponseAllSRoles()

    const destination = 'Member'
    const namespace_search = 'Member_searchValue'

    const SearchConfig = [
        {
            namespace: namespace_search,
            destination: destination,
            input: [
                {
                    id: 'search_emailr',
                    translation: 'common.email',
                    param: 'email',
                    method: 'like',
                },
            ],
            button: ['common.search', 'common.del.search', 'user.create'],
        },
    ]

    const Configuration = {
        tableBody: {
            data: response,
            dataID: 'id',
            underdata: true,
            keys: ['is_active', 'email', 'first_name', 'last_name', 'discr'],
            type: ['status', 'string', 'string', 'string', 'string'],
        },
        tableHeader: [
            <IntlMessage Store={Store} messageId="common.status"/>,
            <IntlMessage Store={Store} messageId="common.email"/>,
            <IntlMessage Store={Store} messageId="common.name.first"/>,
            <IntlMessage Store={Store} messageId="common.name.last"/>,
            <IntlMessage Store={Store} messageId="permissions"/>,
        ],
        tableHeaderWidth: ['20%', '20%', '20%', '20%', '20%'],
        tablecolor: ['light'],
        menu: {
            data: response,
            menuDisable: false,
            menuItem: [
                <IntlMessage Store={Store} messageId="common.edit"/>,
                <IntlMessage Store={Store} messageId="common.delete"/>,
            ],
            menuroute: ['/Member/Detail', '/Member/Delete'],
            menuParams: ['id', 'id'],
            menuIcons: ['pencil', 'Delete'],
        },
    }

    const noNewButton =
        Array.isArray(response) && response.length > 0
            ? response[0].CanCreate === 0
            : false

    if (response !== true && response.length > 0 && localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined) {
        let Rigths = JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string)

        if (load === 0) {
            setLoad(1)
        }


        return (
            <>
                <SearchJSX
                    setSearchValue={setSearchValue}
                    Store={Store}
                    noNewButton={noNewButton}
                    SearchConfig={SearchConfig}
                    reloadButton={refresh(
                        setFetchData,
                        IntlMessageValue('de', 'common.reloadPage', Store)
                    )}
                />

                <TableMaker Configuration={Configuration}/>


                <PaginationJSX
                    response={response}
                    history={history}
                    to={'overview'}
                    handleSuccess={handleSucces}
                    destination={destination}
                />

            </>
        )
    } else {
        localStorage.setItem('searchInput', '')
        localStorage.setItem('searchSelect', '')
        return (
            <>
                <SpinnerJSX messageId={'common.loading'} Store={Store}/>
            </>
        )
    }
}


export default EmployeeOverview
